var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.246 1.461a.917.917 0 0 1 .837-.544 3.667 3.667 0 0 1 3.667 3.666v2.75h4.267a2.75 2.75 0 0 1 2.744 3.163l-1.265 8.25a2.751 2.751 0 0 1-2.744 2.337H3.667a2.75 2.75 0 0 1-2.75-2.75v-6.416a2.75 2.75 0 0 1 2.75-2.75H5.82L9.246 1.46Zm-1.913 8.817 3.307-7.441a1.833 1.833 0 0 1 1.276 1.746V8.25c0 .506.41.917.917.917H18.031a.916.916 0 0 1 .918 1.053l-1.266 8.25a.916.916 0 0 1-.916.78H7.333v-8.972ZM5.5 19.25V11H3.667a.917.917 0 0 0-.917.917v6.416a.917.917 0 0 0 .917.917H5.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsUp;